import { Component } from 'react';

type Props = {
  children: (mounted: boolean) => JSX.Element;
  delay?: number;
};

type State = {
  mounted: boolean;
};

export class MountedStateProvider extends Component<Props, State> {
  private timeoutToken: number | null = null;
  private unmounted: boolean = false;

  constructor(props: Props) {
    super(props);
    this.state = {
      mounted: false,
    };
  }

  render() {
    return this.props.children(this.state.mounted);
  }

  componentDidMount() {
    if (this.props.delay) {
      this.timeoutToken = window.setTimeout(() => {
        if (this.unmounted === false) {
          this.setState({ mounted: true });
        }
      }, this.props.delay);
    } else {
      this.setState({ mounted: true });
    }
  }

  componentWillUnmount() {
    this.unmounted = true;
    if (this.timeoutToken !== null) {
      window.clearTimeout(this.timeoutToken);
    }
  }
}



// WEBPACK FOOTER //
// ./src/module/View/Common/component/MountedStateProvider/index.tsx